<template>
  <div class="view cookies">
    <div class="content">
      <div class="title">
        {{ $t('cookies') }}
      </div>
      <div class="text" v-html="$t('cookiesDetail')"></div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$store.dispatch('acceptCookies');
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';
@use '@/styles/animations.scss';

.content {
  margin: 0 auto;
  padding: 48px 0 96px;
  width: 75%;
  min-width: 960px;
  max-width: 1536px;

  .title {
    font-size: 32px;
    font-weight: 600;
    color: #3c3c3b;

    &:after {
      content: ' ';
      display: block;
      margin-top: 8px;
      width: 64px;
      height: 2px;
      background-color: colors.$main-color;
      border-radius: 2px;
      margin-bottom: 18px;
    }
  }
}
</style>

<style lang="scss">
.cookies .text {
  h1 {
    font-family: 'Golden Plains';
    font-weight: 100;
    font-size: 64px;
    margin: 32px 0 0;
  }

  h2 {
    color: #3c3c3b;
    font-weight: 600;
    font-size: 1.4em;
    margin: 24px 0 8px;
  }

  h3 {
    font-size: 1.4em;
    margin: 12px 0 6px;
  }

  h4 {
    font-size: 1.2em;
    margin: 8px 0;
  }
}
</style>
